import { routerReducer as router } from "react-router-redux";
import { reducer as reducerForm } from "redux-form";
import patients from "./patients";
import login from "./login";
import jwtToken from "./jwtToken";
import popupReducer from "./popupReducer";
import chat from "./chat";
import unreadReducer from "./unreadReducer";

import activePatient from "./activePatients";
import unClaimed from "./unclaimedPatient";
import otherPatients from "./otherPatient";
import queuedPatient from "./queuedPatient";
import loadChat from "./loadChat";
import claimedUser from "./claimedUser";
import patientCount from "./patientCount";
import noInternet from "./noInternet";
import liveAgentChat from "./liveAgentChat";
import liveAgentChatCount from "./liveAgentChatCount";
import revokeByAgent from "./revokeByAgent";
import ClaimChat from "./claimChat";
import notificationAlert from "./notificationAlert";
import notificationCount from "./notificationCount";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  form: reducerForm,
  patients,
  router,
  login,
  jwtToken,
  chat,
  activePatient,
  unClaimed,
  otherPatients,
  loadChat,
  claimedUser,
  patientCount,
  popupReducer,
  noInternet,
  liveAgentChat,
  liveAgentChatCount,
  revokeByAgent,
  ClaimChat,
  unreadReducer,
  notificationAlert,
  notificationCount,
  queuedPatient,
});

export default rootReducer;
